// extracted by mini-css-extract-plugin
export default {"pageContentWrapper":"GoalPage_pageContentWrapper__3wl7z"};